import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=940658be&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940658be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('940658be')) {
      api.createRecord('940658be', component.options)
    } else {
      api.reload('940658be', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=940658be&scoped=true&", function () {
      api.rerender('940658be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Sp7HggW4i7ad/JS/comp/Accordion.vue"
export default component.exports